import { findBy$IdInTreeList, findByIdInTreeList } from "../../utils/tree";
import { toggleShowProjectContextMenu } from "../../redux/actions/showProjectContextMenuAction";
import { editTaskInFirebase } from "../../redux/actions/TodoManipulation/editTaskInFirebaseAction";
import { Tooltip } from "react-tooltip";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useIsMobile } from "../../functions/deviceIdentity/getDeviceType";

export const SearchTodo = ({ todo, projects, zoomLevel }) => {
    const { title, id, color, $id, isCompleted, globalPriority } = todo;
    const dispatch = useDispatch();
    let parent;
    if (todo.parent) {
        parent = findBy$IdInTreeList(projects, todo.parent.$ref);
    }
    const getTaskColor = () => {
        if (color) return color.hexString;
        if (parent && parent.color) return parent.color.hexString;
        return '#80C3E9';
    };
    const [taskColor, setTaskColor] = useState(getTaskColor());
    const [isHovered, setIsHovered] = useState(false);
    const isMobile = useIsMobile();
    const toggleContextMenu = (projectId) => {
        dispatch(toggleShowProjectContextMenu(projectId));
    };
    const handleMouseOver = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    function isNullOrUndefined(value) {
        return value === undefined || value === null;
    }
    const updateIsCompleted = async () => {
        console.log("IsCompleted", isCompleted);

        const json = {
            id: id,
            Title: title,
            IsCompleted: !isCompleted,
            HasDescription: (isNullOrUndefined(todo.hasDescription)) ? false.toString() : todo.hasDescription,
            Description: todo.description,
            HasDueDate: (isNullOrUndefined(todo.hasDueDate)) ? false.toString() : todo.hasDueDate,
            DueDate: todo.dueDate,
            VisualSize: todo.visualSize.toString(),
            HasSnoozedUntil: (isNullOrUndefined(todo.hasSnoozedUntil)) ? false.toString() : todo.hasSnoozedUntil,
            SnoozedUntil: todo.snoozedUntil
        }

        await dispatch(editTaskInFirebase(json));
    };

    const toggleShowModal = (taskId, event) => {
        const allowedClassNames = [
            "gw-icon-button",
            "gt-task__completed",
            "gw-icon-button__icon"
        ];

        if (!allowedClassNames.some(className => event.target.classList.contains(className))) {
            const todoItem = findByIdInTreeList(projects, taskId);
            dispatch({ type: "TOGGLE_EDIT_MODAL", payload: { todo: todoItem } });
        }
    };
    useEffect(() => { setTaskColor(getTaskColor()); }, [todo]);
    return (<div className="gt-task" style={{ fontSize: isMobile ? '10px' : `${zoomLevel}px` }} onClick={(event) => {
        toggleShowModal(id, event);
        event.stopPropagation();
    }}>
        <div className="gt-task__color" style={{ background: taskColor }}></div>
        <a data-tooltip-id="my-tooltip">
            
            <input
                className={isHovered ? "gt-task__completed gt-task-completed-background-checked" : "gt-task__completed"}
                type="checkbox"
                aria-label="Task completed?"
                onChange={updateIsCompleted}
                checked={isCompleted}
                onMouseOver={handleMouseOver}
                onMouseLeave={handleMouseLeave}
            />
        </a>
        <Tooltip id="tooltip-completed">Mark as completed</Tooltip>
        <p className="gt-task__title">{title}</p>
       

    </div>);
}